import React from 'react';

const PanelEdicion = ({ abierto, titulo, ancho, onArrastre, onCerrar, secciones, seccionActiva, onSeccion, hayCambios, pie, children }) => {
    const irASeccion = id => {
        onSeccion?.(id);
        document.getElementById('seccion_' + id)?.scrollIntoView({ block: 'start', behavior: 'smooth' });
    };

    return (
        <aside className={'panel_edicion' + (abierto ? ' panel_edicion_abierto' : '')} style={{ width: ancho }} aria-hidden={!abierto}>
            <div className='panel_edicion_encabezado'>
                <p className='titulo_1_admin' style={{ margin: 0 }}>{titulo}</p>
                <button type='button' className='modal_admin_cerrar' onClick={onCerrar} aria-label='Cerrar'>&times;</button>
            </div>
            {secciones?.length > 0 && (
                <div className='panel_edicion_secciones'>
                    {secciones.map(({ id, titulo }) => (
                        <button
                            type='button'
                            key={id}
                            className={'panel_edicion_chip' + (seccionActiva === id ? ' panel_edicion_chip_activo' : '')}
                            onClick={() => irASeccion(id)}
                        >
                            {titulo}
                        </button>
                    ))}
                </div>
            )}
            <div className='panel_edicion_cuerpo'>
                {children}
            </div>
            {pie && (
                <div className='panel_edicion_pie'>
                    {hayCambios && <span className='panel_edicion_pendiente'>Cambios sin guardar</span>}
                    {pie}
                </div>
            )}
            <div className='panel_edicion_asa' onMouseDown={onArrastre} title='Arrastra para cambiar el ancho' />
        </aside>
    );
};

export default PanelEdicion;
